import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /** The bulk upload type chosen from the listing, shown in the modal. */
  selectedUploadType: null,
};

const bulkOrderSlice = createSlice({
  name: "bulkOrder",
  initialState,
  reducers: {
    setSelectedUploadType(state, action) {
      state.selectedUploadType = action.payload;
    },
    clearSelectedUploadType(state) {
      state.selectedUploadType = null;
    },
  },
});

export const { setSelectedUploadType, clearSelectedUploadType } =
  bulkOrderSlice.actions;

export default bulkOrderSlice.reducer;
